import { createElement, useEffect } from 'react';
import './index.scss';
import * as echarts from 'echarts';
import china from 'echarts/map/json/china';
import shanghai from 'echarts/map/json/province/shanghai';
import anhui from 'echarts/map/json/province/anhui';
import aomen from 'echarts/map/json/province/aomen';
import beijing from 'echarts/map/json/province/beijing';
import chongqing from 'echarts/map/json/province/chongqing';
import fujian from 'echarts/map/json/province/fujian';
import gansu from 'echarts/map/json/province/gansu';
import guangdong from 'echarts/map/json/province/guangdong';
import guangxi from 'echarts/map/json/province/guangxi';
import guizhou from 'echarts/map/json/province/guizhou';
import hainan from 'echarts/map/json/province/hainan';
import hebei from 'echarts/map/json/province/hebei';
import heilongjiang from 'echarts/map/json/province/heilongjiang';
import henan from 'echarts/map/json/province/henan';
import hubei from 'echarts/map/json/province/hubei';
import hunan from 'echarts/map/json/province/hunan';
import jiangsu from 'echarts/map/json/province/jiangsu';
import jiangxi from 'echarts/map/json/province/jiangxi';
import jilin from 'echarts/map/json/province/jilin';
import liaoning from 'echarts/map/json/province/liaoning';
import neimenggu from 'echarts/map/json/province/neimenggu';
import ningxia from 'echarts/map/json/province/ningxia';
import qinghai from 'echarts/map/json/province/qinghai';
import shandong from 'echarts/map/json/province/shandong';
import shanxi from 'echarts/map/json/province/shanxi';
import shanxi1 from 'echarts/map/json/province/shanxi1';
import sichuan from 'echarts/map/json/province/sichuan';
import taiwan from 'echarts/map/json/province/taiwan';
import xianggang from 'echarts/map/json/province/xianggang';
import xinjiang from 'echarts/map/json/province/xinjiang';
import xizang from 'echarts/map/json/province/xizang';
import yunnan from 'echarts/map/json/province/yunnan';
import zhejiang from 'echarts/map/json/province/zhejiang';
import chinaCities from 'echarts/map/json/china-cities';
import chinaContour from 'echarts/map/json/china-contour';
import world from 'echarts/map/json/world';
const EchartMap = function EchartMap({ title, description, color, style, data = [], mapName, ...otherProps }) {
    let serv = {};
    const id = `test${Math.random()}`;
    function barChart() {
        const mapObject = {
            china,
            shanghai,
            chinaCities,
            chinaContour,
            world,
            anhui,
            aomen,
            beijing,
            chongqing,
            fujian,
            gansu,
            guangdong,
            guangxi,
            guizhou,
            hainan,
            hebei,
            heilongjiang,
            henan,
            hubei,
            hunan,
            jiangsu,
            jiangxi,
            jilin,
            liaoning,
            neimenggu,
            ningxia,
            qinghai,
            shandong,
            shanxi,
            shanxi1,
            sichuan,
            taiwan,
            xianggang,
            xinjiang,
            xizang,
            yunnan,
            zhejiang,
        };
        const myChart = echarts.init(document.getElementById(id));
        echarts.registerMap(mapName, mapObject[mapName]);
        myChart.clear();
        myChart.resize({
            width: style.width,
            height: style.height,
        });
        const dataSer = [];
        data.forEach((item) => {
            dataSer.push({
                name: item.name,
                value: item.value[2],
            });
        });
        const option = {
            backgroundColor: style.backgroundColor,
            title: {
                show: title.visible,
                left: 20,
                top: 20,
                text: title.text,
                subtext: title.description,
                x: 'left',
                textStyle: {
                    color: '#274d68',
                },
            },
            tooltip: {
                trigger: 'item',
                formatter(params) {
                    return `${params.name} : ${params.value}`;
                },
            },
            geo: {
                map: mapName,
                aspectScale: 0.75,
                zoom: 1.1,
                roam: false,
                itemStyle: {
                    normal: {
                        areaColor: {
                            type: 'radial',
                            x: 0.5,
                            y: 0.5,
                            r: 0.8,
                            colorStops: [
                                {
                                    offset: 0,
                                    color: '#09132c',
                                },
                                {
                                    offset: 1,
                                    color: '#274d68',
                                },
                            ],
                            globalCoord: true,
                        },
                        shadowColor: 'rgb(58,115,192)',
                        shadowOffsetX: 10,
                        shadowOffsetY: 11,
                    },
                    emphasis: {
                        areaColor: '#2AB8FF',
                        borderWidth: 0,
                        color: 'green',
                        label: {
                            show: false,
                        },
                    },
                },
                regions: [
                    {
                        name: '南海诸岛',
                        itemStyle: {
                            areaColor: 'rgba(0, 10, 52, 1)',
                            borderColor: 'rgba(0, 10, 52, 1)',
                            normal: {
                                opacity: 0,
                                label: {
                                    show: false,
                                    color: '#009cc9',
                                },
                            },
                        },
                    },
                ],
            },
            series: [
                {
                    name: 'credit_pm2.5',
                    type: 'effectScatter',
                    left: '150',
                    coordinateSystem: 'geo',
                    data,
                    symbolSize(val) {
                        return val[2] / 8;
                    },
                    showEffectOn: 'render',
                    rippleEffect: {
                        brushType: 'stroke',
                    },
                    hoverAnimation: true,
                    label: {
                        normal: {
                            formatter: '{b}',
                            position: 'bottom',
                            color: '#1DE9B6',
                            show: true,
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#10f9ff',
                            shadowBlur: 0,
                            shadowColor: '#05C3F9',
                        },
                    },
                    zlevel: 1,
                },
                {
                    type: 'map',
                    roam: false,
                    label: {
                        normal: {
                            show: false,
                            textStyle: {
                                color: '#1DE9B6',
                            },
                        },
                        emphasis: {
                            textStyle: {
                                color: 'rgb(183,185,14)',
                            },
                        },
                    },
                    itemStyle: {
                        normal: {
                            borderColor: 'rgb(147, 235, 248)',
                            borderWidth: 1,
                            areaColor: {
                                type: 'radial',
                                x: 0.5,
                                y: 0.5,
                                r: 0.8,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: '#09132c',
                                    },
                                    {
                                        offset: 1,
                                        color: '#274d68',
                                    },
                                ],
                                globalCoord: true,
                            },
                        },
                        emphasis: {
                            areaColor: 'rgb(46,229,206)',
                            borderWidth: 0.1,
                        },
                    },
                    zoom: 1.1,
                    map: mapName,
                    data: dataSer,
                },
            ],
        };
        myChart.setOption(option);
        myChart.on('click', 'series', (e) => {
            serv = e;
            console.log(serv, 'serv');
        });
    }
    useEffect(() => {
        barChart();
    });
    return (createElement("div", { style: style },
        createElement("div", { id: id, ...otherProps, onClick: (e) => otherProps.onClick(e, serv) })));
};
export default EchartMap;
